var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSubmittedAndCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 38.738,
    viewBox: "0 0 104 38.738",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_80_1",
    "data-name": "Component 80 \\u2013 1",
    transform: "translate(0 1.387)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SUBMITTED",
    transform: "translate(0 34.352)",
    fill: "#b9b8b8",
    fontSize: 14,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "0.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SUBMITTED")), /*#__PURE__*/React.createElement("g", {
    id: "Component_53_58",
    "data-name": "Component 53 \\u2013 58",
    transform: "translate(44)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_92",
    "data-name": "Line 92",
    x1: 10,
    y2: 15,
    transform: "translate(5)",
    fill: "none",
    stroke: "#b9b8b8",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    "data-name": "Line 93",
    x2: 5,
    y2: 7,
    transform: "translate(0 8)",
    fill: "none",
    stroke: "#b9b8b8",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSubmittedAndCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/SubmittedAndCheck.c12a6f89.svg";
export { ForwardRef as ReactComponent };